import React from "react";
import cx from "classnames";
import { useDrag } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";

import { FieldPrimaryListDto } from "@common/dto/field/list-primary-dto";
import { FieldColumnKey } from "../../fields.types";

import "./field.styles.scss";

type FieldProps = {
  className?: string;
  field: FieldPrimaryListDto;
  isSelected?: boolean;
  onMouseDown: (params: { item: FieldPrimaryListDto; event: React.MouseEvent<HTMLDivElement> }) => void;
  onMouseUp: (params: { item: FieldPrimaryListDto; event: React.MouseEvent<HTMLDivElement> }) => void;
  tableColumnsConfig: Array<{ label: string; field: FieldColumnKey }>;
  getId: {
    rowId: string;
    rowColumnId: string;
  };
  onDrag: (item: FieldPrimaryListDto) => void;
};

export const Field: React.FC<FieldProps> = (props) => {
  const { className, field, isSelected, tableColumnsConfig, getId, onMouseDown, onMouseUp, onDrag } = props;

  const [{}, dragRef, dragPreview] = useDrag({
    type: "field",
    item: () => field,
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult) {
        onDrag(item);
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  React.useEffect(function hideDefaultPreview() {
    dragPreview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  return (
    <div className={cx("QueryCreatingFolderField", className)}>
      <div
        key={field.id}
        id={getId.rowId}
        className={cx("QueryCreatingFolderField__content__row", {
          "QueryCreatingFolderField__content__row--selected": isSelected,
        })}
        onMouseDown={(event: React.MouseEvent<HTMLDivElement>) => onMouseDown({ item: field, event })}
        onMouseUp={(event: React.MouseEvent<HTMLDivElement>) => onMouseUp({ item: field, event })}
        ref={dragRef}
      >
        {tableColumnsConfig.map((config, colIndex) => (
          <div
            style={{ width: `${100 / tableColumnsConfig.length}%` }}
            key={config.field}
            id={`${getId.rowColumnId}-${colIndex}`}
            className="QueryCreatingFolderField__table__cell"
          >
            {config.field === FieldColumnKey.name && (
              <img
                className="QueryCreatingFolderField__table__cell__icon"
                src={field.imageURL}
                alt={field[config.field]}
              />
            )}
            {field[config.field]}
          </div>
        ))}
      </div>
    </div>
  );
};
